import { mapActions } from "vuex"
export default {
    methods: {
        ...mapActions({
            getCatalogue: "Catalogue/getCatalogue",
        }),
        loadCatalogues(catalogues) {
            return Promise.all(catalogues.map(c => this.getCatalogue(c)))
        },
    }
}